<!-- <div class="fixed top-1/4 right-0 flex flex-col gap-1.5 items-end" > -->
<div
  class="fixed top-1/4 right-0 flex flex-col gap-1.5 items-end transition-transform duration-300"
  [class.translate-x-full]="!sidebarVisible"
>
  <!-- Home -->
  <a
    routerLink="/"
    (mouseenter)="setHovered('home')"
    [routerLinkActiveOptions]="{ exact: true }"
    (mouseleave)="setHovered(null)"
    routerLinkActive="active-primary"
    class="text-[var(--secondary)] px-3 py-3 rounded-l-full flex items-center hover:text-[var(--primary)] text-3xl overflow-hidden transition-colors duration-200"
  >
    <fa-icon [icon]="faHome"></fa-icon>
    <span
      [@labelState]="hoveredItem === 'home' ? 'hovered' : 'normal'"
      class="ml-2 whitespace-nowrap text-base font-medium inline-block"
    >
      Home
    </span>
  </a>

  <!-- Products -->
  <a
    routerLink="/products"
    (mouseenter)="setHovered('products')"
    (mouseleave)="setHovered(null)"
    routerLinkActive="active-primary"
    class="text-[var(--secondary)] px-3 py-3 rounded-l-full flex items-center hover:text-[var(--primary)] text-3xl overflow-hidden transition-colors duration-200"
  >
    <fa-icon [icon]="faBoxOpen"></fa-icon>
    <span
      [@labelState]="hoveredItem === 'products' ? 'hovered' : 'normal'"
      class="ml-2 whitespace-nowrap text-base font-medium inline-block"
    >
      Products
    </span>
  </a>

  <!-- Gifts -->
  <a
    routerLink="/gifts"
    (mouseenter)="setHovered('gifts')"
    (mouseleave)="setHovered(null)"
    routerLinkActive="active-primary"
    class="text-[var(--secondary)] px-3 py-3 rounded-l-full flex items-center hover:text-[var(--primary)] text-3xl transition-colors duration-200"
  >
    <div class="relative inline-block">
      <fa-icon [icon]="faGift"></fa-icon>
      <span
        class="bg-gradient-to-r from-pink-500 to-purple-600 animate-pulse w-18 text-center text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full absolute -top-4 right-6 shadow-sm"
      >
        Coming Soon
      </span>
    </div>
    <span
      [@labelState]="hoveredItem === 'gifts' ? 'hovered' : 'normal'"
      class="ml-2 whitespace-nowrap text-base font-medium inline-flex items-center gap-1"
    >
      Gifts
    </span>
  </a>

  <!-- Designs -->
  <a
    routerLink="/designs"
    (mouseenter)="setHovered('designs-lab')"
    (mouseleave)="setHovered(null)"
    routerLinkActive="active-primary"
    class="text-[var(--secondary)] px-3 py-3 rounded-l-full flex items-center hover:text-[var(--primary)] text-3xl transition-colors duration-200"
  >
    <div class="relative inline-block">
      <fa-icon [icon]="faPalette" class="text-3xl"></fa-icon>
      <span
        class="bg-gradient-to-r from-pink-500 to-purple-600 animate-pulse w-18 text-center text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full absolute -top-4 right-6 shadow-sm"
      >
        Coming Soon
      </span>
    </div>

    <span
      [@labelState]="hoveredItem === 'designs-lab' ? 'hovered' : 'normal'"
      class="ml-2 whitespace-nowrap text-base font-medium inline-flex items-center gap-1"
    >
      Designs
    </span>
  </a>

  <!-- Profile -->
  <a
    routerLink="/profile"
    (mouseenter)="setHovered('profile')"
    (mouseleave)="setHovered(null)"
    routerLinkActive="active-primary"
    class="text-[var(--secondary)] px-3 py-3 rounded-l-full flex items-center hover:text-[var(--primary)] text-3xl overflow-hidden transition-colors duration-200"
  >
    <fa-icon [icon]="faUser"></fa-icon>
    <span
      [@labelState]="hoveredItem === 'profile' ? 'hovered' : 'normal'"
      class="ml-2 whitespace-nowrap text-base font-medium inline-block"
    >
      Profile
    </span>
  </a>

  <!-- Orders -->
  <a
    routerLink="/orders"
    routerLinkActive="active-primary"
    (mouseenter)="setHovered('orders')"
    (mouseleave)="setHovered(null)"
    class="text-[var(--secondary)] px-3 py-3 rounded-l-full flex items-center hover:text-[var(--primary)] text-3xl overflow-hidden transition-colors duration-200"
  >
    <fa-icon [icon]="faReceipt"></fa-icon>
    <span
      [@labelState]="hoveredItem === 'orders' ? 'hovered' : 'normal'"
      class="ml-2 whitespace-nowrap text-base font-medium inline-block"
    >
      Orders
    </span>
  </a>
</div>
<!-- Toggle Button at Bottom -->
<button
  (click)="toggleSidebar()"
  class="mt-4 px-3 py-2 rounded-l-full cursor-pointer bg-[var(--primary)] text-white text-xl flex items-center justify-center fixed bottom-4 right-0 transition-colors duration-200"
>
  <fa-icon [icon]="sidebarVisible ? faChevronRight : faChevronLeft"></fa-icon>
</button>
